import { registerActivity } from "../registry";
import { WorkflowActivityDefinition } from "../types";

export const Branch: WorkflowActivityDefinition = {
  group: 'internal',
  name: 'branch',
  type: 'activity',
  schema: {
    type: 'object',
    properties: {
      branches: {
        type: 'array',
        items: {
          type: 'object',
        },
      },
    },
    required: ['branches'],
  },
  defaults: {
    branches: [],
  },
  // outputs: ['branches'],
};

export type BranchType = typeof Branch;

registerActivity(Branch);